export type ApiResponse<T = unknown> = {
  success?: boolean;
  message?: string;
  error?: string;
  type?: string;
  status?: number;
  errors?: Record<string, string[]>;
  data?: T;
  pagination?: {
    total: number;
    current_page: number;
    per_page: number;
    last_page: number;
    next_page_url?: string | null;
  };
} & (
  | { success: true; data: T }
  | { success: false; error?: string; message?: string; errors?: Record<string, string[]> }
);

export class ApiError extends Error {
  status?: number;
  error?: string;
  errors?: Record<string, string[]>;

  constructor({
    message,
    status,
    error,
    errors,
  }: { message: string; status?: number; error?: string; errors?: Record<string, string[]> }) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.error = error;
    this.errors = errors;
  }
}
